import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FieldDataChangedEvent } from "devextreme/ui/form";

@Component({
  selector: "snt-report-form-rederer-check",
  templateUrl: "report-form-renderer-check.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererCheckComponent implements OnInit {
  @Input()
  item!: any;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  formData = {
    value: ""
  };

  ngOnInit(): void {
    // TODO probabilmente this.item.text va rimosso
    this.formData.value = this.item.value || this.item.text || "";
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "text",
      config: {
        title: this.item.config.title,
        value: this.formData.value
      }
    };
  }

  onFieldDataChanged({ value, dataField }: FieldDataChangedEvent): void {
    this.item.value = value;

    this.value.emit(value);
  }
}
